import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MacroRegimeRow {
  id: string;
  week_ending: string;
  computed_at: string;
  regime: 'expansion' | 'contraction' | 'transition' | string;
  previous_regime: string | null;
  is_transition: boolean;
  net_liq_yoy_pct: number | null;
  glp_v2_value: number | null;
  btc_close_usd: number | null;
  rolling_r: number | null;
  signal_strength: 'moderate' | 'weak' | string | null;
  lead_estimate_weeks: number | null;
  observation_note: string | null;
  notified: boolean;
}

export function useLatestMacroRegime() {
  return useQuery<MacroRegimeRow | null>({
    queryKey: ['macro-regime-latest'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('macro_regime')
        .select('*')
        .order('week_ending', { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return (data as MacroRegimeRow | null) ?? null;
    },
    refetchInterval: 60 * 60 * 1000,
    staleTime: 30 * 60 * 1000,
  });
}

export function useMacroRegimeHistory(limit = 200) {
  return useQuery<MacroRegimeRow[]>({
    queryKey: ['macro-regime-history', limit],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('macro_regime')
        .select('*')
        .order('week_ending', { ascending: false })
        .limit(limit);
      if (error) throw error;
      return (data as MacroRegimeRow[]) ?? [];
    },
    staleTime: 30 * 60 * 1000,
  });
}
